'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'megaphone';
var width = 512;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = 'M480 32c-17.7 0-32 14.3-32 32l0 9.1-385.2 110.1C59 169.8 46.6 160 32 160 14.3 160 0 174.3 0 192L0 320c0 17.7 14.3 32 32 32 14.6 0 27-9.8 30.8-23.2l71.7 20.5c-4.2 10.8-6.5 22.5-6.5 34.7 0 53 43 96 96 96 46.9 0 86-33.7 94.3-78.2l129.7 37 0 9.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32zM271.8 388.5c-2.3 24.4-22.8 43.5-47.8 43.5-26.5 0-48-21.5-48-48 0-7.7 1.8-15 5-21.4l90.8 25.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMegaphone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;